module.exports = __webpack_public_path__ + "img/moe-img.b982abd1.png";